import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstructuraOrganizacionalPuestosDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstructuraOrganizacionalPuestosService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getEstructuraOrganizacionalPuestosService(): Observable<BodyListResponse<EstructuraOrganizacionalPuestosDTO>> {
    return this.http.get<BodyListResponse<EstructuraOrganizacionalPuestosDTO>>(API_URL + '/api/v1/estructuraOrganizacionalPuestos/todos');
  }

  guardarEstructuraOrganizacionalPuestosService(estructuraOrganizacionalPuestosDTO: EstructuraOrganizacionalPuestosDTO): Observable<any> {
    return this.http.post<EstructuraOrganizacionalPuestosDTO>(API_URL + '/api/v1/estructuraOrganizacionalPuestos', estructuraOrganizacionalPuestosDTO);
  }

  getEstructuraOrganizacionalPuestosPorCodigoEstructuraOrganizacionalPuestoService(codigoEstructuraOrganizacionalPuesto: string): Observable<BodyResponse<EstructuraOrganizacionalPuestosDTO>> {
    return this.http.get<BodyResponse<EstructuraOrganizacionalPuestosDTO>>(API_URL + '/api/v1/estructuraOrganizacionalPuestos/' + codigoEstructuraOrganizacionalPuesto);
  }
}
